<template>
    <v-sheet class="">
        <v-row no-gutters>
            <plotly :data="ofpPlotData" :layout="plotLayout"></plotly>
        </v-row>
        <v-row no-gutters>
            <v-col>
                <v-text-field dense persistent-hint type="number" v-model="a">
                    <template #prepend><p>a</p></template>
                </v-text-field>
            </v-col>
        </v-row>
        <v-row no-gutters>
            <v-col>
                <v-text-field dense persistent-hint type="number" v-model="no">
                    <template #prepend><p>n<sub>o</sub></p></template>
                </v-text-field>
            </v-col>
        </v-row>
        <v-row no-gutters>
            <v-col>
                <v-text-field dense persistent-hint type="number" v-model="nw" label="nw">
                    <template #prepend><p>n<sub>w</sub></p></template>
                </v-text-field>
            </v-col>
        </v-row>
    </v-sheet>
</template>

<script>
import { Plotly } from 'vue-plotly';

export default {
    props: ['value', 'siw', 'sor'],
    emits: ['input'],
    components: { Plotly },
    data() {
        return {
            a: this.value?.a || 0.6,
            no: this.value?.no || 2,
            nw: this.value?.nw || 2,
        }
    },
    created() {
        this.emitChanges();
    },
    watch: {
        a() {
            this.emitChanges();
        },
        no() {
            this.emitChanges();
        },
        nw() {
            this.emitChanges();
        },
    },
    methods: {
        krw(x, a, nw) {
            let siw = this.siw;
            let sor = this.sor;
            return a * ((x-siw)/(1-siw-sor))**nw;
        },
        kro(x, no) {
            let siw = this.siw;
            let sor = this.sor;
            return ((1-x-sor)/(1-siw-sor))**no;
        },
        emitChanges() {
            this.$emit('input', {
                a: parseFloat(this.a),
                no: parseFloat(this.no),
                nw: parseFloat(this.nw)
            });
        }
    },
    computed: {
        ofpPlotData() {
            let a = this.a;
            let no = this.no;
            let nw = this.nw;

            if (a && no && nw) {
                let steps = 101;
                let sw = Array(steps).fill(0).map((_, i) => i/steps);
                let kro = sw.map(x => this.kro(x, no));
                let krw = sw.map(x => this.krw(x, a, nw));

                return [
                    {
                        x: sw,
                        y: kro,
                        mode: 'lines',
                        type: 'scatter',
                        name: 'Kro',
                    },
                    {
                        x: sw,
                        y: krw,
                        mode: 'lines',
                        type: 'scatter',
                        name: 'Krw'
                    }
                ]
            }

            return [];
        },
        plotLayout() {
            return {
                margin: {
                    pad: 16
                },
                xaxis: {
                    title: 'Sw',
                    range: [this.siw || 0, 1-(this.sor || 0)],
                },
                yaxis: {
                    range: [0, 1]
                }
            };
        }
    }
}
</script>

<style scoped>

</style>